import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import { GENDER } from "../../../../constants/master";
import { NEW_PATIENT_INITIAL_VALUES } from "../../../../constants/scheduling";
import { __type_builder } from "../../../../utils/type-builder";
import CustomDatePicker from "../../../CustomDatePicker";
import CustomSelect from "../../../CustomSelect";
import Flex from "../../../Flex";
import Input from "../../../Input";
import MaskInput from "../../../MaskInput";
import dayjs from "dayjs";

interface PatientRegistrationGenericFormProps {
  formik: FormikProps<__type_builder<typeof NEW_PATIENT_INITIAL_VALUES>>;
  row?: number;
}

const PatientRegistrationGenericForm = ({
  formik,
  row = 4,
}: PatientRegistrationGenericFormProps) => {
  return (
    <Flex width={"100%"}>
      <Grid container spacing={3}>
        <Grid size={row}>
          <Input
            required
            label="First Name"
            textFieldProps={{
              placeholder: "Enter First Name",
              onChange: formik.handleChange,
              name: "firstName",
              value: formik.values.firstName,
            }}
            error={formik.touched.firstName && formik.errors.firstName}
          />
        </Grid>
        <Grid size={row}>
          <Input
            // required
            label="Middle Name"
            textFieldProps={{
              placeholder: "Enter Middle Name",
              onChange: formik.handleChange,
              name: "middle_name",
              value: formik.values.middle_name,
            }}
            error={formik.touched.middle_name && formik.errors.middle_name}
          />
        </Grid>
        <Grid size={row}>
          <Input
            required
            label="Last Name"
            textFieldProps={{
              placeholder: "Enter Last Name",
              onChange: formik.handleChange,
              name: "lastName",
              value: formik.values.lastName,
            }}
            error={formik.touched.lastName && formik.errors.lastName}
          />
        </Grid>
        <Grid size={row}>
          <CustomDatePicker
            required
            label="Date of Birth"
            value={formik.values.birthDate}
            maxDate={dayjs()}
            onChange={(val) => {
              formik.setFieldValue("birthDate", val);
            }}
            error={formik.touched?.birthDate && formik.errors?.birthDate}
          />
        </Grid>
        <Grid size={row}>
          <CustomSelect
            name="gender"
            required
            label="Gender"
            options={GENDER}
            value={formik.values.gender}
            onChange={(val) => {
              formik.setFieldValue("gender", val);
            }}
            error={formik.touched.gender && formik.errors.gender}
          />
        </Grid>
        <Grid size={row}>
          <Input
            // required
            label="Email"
            textFieldProps={{
              name: "email",
              placeholder: "Enter Email",
              onChange: formik.handleChange,
              onBlur: formik.handleBlur,
              value: formik.values.email,
            }}
            // error={formik.touched?.email && formik.errors?.email}
          />
        </Grid>
        <Grid size={row}>
          <MaskInput
            mask={"(999) 999-9999"}
            label="Mobile Number"
            placeholder="Enter Mobile Number"
            value={formik.values?.mobileNumber}
            onChange={(e) =>
              formik.setFieldValue("mobileNumber", e.target.value)
            }
          />
        </Grid>
      </Grid>
    </Flex>
  );
};

export default PatientRegistrationGenericForm;
